// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header{
    position: fixed;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px 10px;
    padding-right: 0;
    /* background: transparent; */
    backdrop-filter: blur(3px);
    z-index: 100;
}
.header .logo {
    cursor: pointer;
}

.header .logo .logo-img{
    width: 100%;
    height: 100%;
    font-size: 50px;
    color: #fff;
    font-weight: 600;
}

.header .logo .logo-img span {
    font-weight: 600;
    color: #F94892;
}

.header .logo .logo-img .blink {
    animation: blink 2s infinite;
}

@keyframes blink {
    0% {
        color: #F94892;
    }

    50% {
        color: transparent;
    }
    100% {
        color: #F94892;
        
    }
}

.header .nav-menu{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    flex-basis: 70%;
}

.nav-menu li{
    width: max-content;
    padding: 10px;
    transform: rotate(270deg);
}

.nav-menu li .navLink{
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}
.nav-menu li .navLink:hover {
    color: #F94892;
}

.nav-menu li {
    transition: all 0.5s ease-in-out;
}

.nav-menu li:hover {
    color: #F94892;
    transform: scale(1.3) rotate(270deg);
}

.header .social-links {
    width: 3rem;
    display: flex;
    flex-direction: column;
}

.header .social-links .social{
    margin: 5px 0;
    width: 100%;
    transition: all 0.5s ease-in-out;
}

.header .hamburger {
    display: none;
}

.header .social-links .social:hover {
    transform: scale(1.5);
    fill: #F94892;
}


@media screen and (max-width: 750px), (max-height: 550px) {
    .header {
        width: 100vw;
        height: auto;
        flex-direction: row;
        padding: 10px 20px;
        z-index: 100;
        backdrop-filter: blur(30px);
    }

    .header .logo {
        width: auto;
        height: auto;
        margin: 0;
    }

    .header .logo .logo-img {
        font-size: 40px;
    }

    .header .hamburger {
        display: initial;
        z-index: 10;
    }

    .header .hamburger .bars {
        height: 100%;
    }

    .header .nav-menu {
        width: 50vw;
        position: absolute;
        top: 0;
        height: 85vh;
        right: -100%;
        transition: 0.5s;
        background: rgb(18, 18, 18);
    }

    .header .nav-menu.active {
        right: 0;
        z-index: 10;
    }

    .header .nav-menu li {
        transform: rotate(0deg);
        padding: 5px 10px;
        z-index: 12;
        transition: all 0.3s ease-in-out;
    }

    .nav-menu li:hover {
        transform: scale(1.12);
    }

    .header .social-links {
        padding: 2rem;
        position: absolute;
        top: 85vh;
        height: 20vh;
        right: -100%;
        width: 50%;
        flex-direction: row;
        justify-content: space-evenly;
        transition: 0.5s;
        z-index: 110;
        background: rgb(18, 18, 18);
    }

    .header .social-links.active {
        right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NavbarStyle.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;;IAElB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;;AAGA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,WAAW;QACX,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,6BAA6B;QAC7B,gBAAgB;QAChB,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".header{\n    position: fixed;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 10px;\n    padding-right: 0;\n    /* background: transparent; */\n    backdrop-filter: blur(3px);\n    z-index: 100;\n}\n.header .logo {\n    cursor: pointer;\n}\n\n.header .logo .logo-img{\n    width: 100%;\n    height: 100%;\n    font-size: 50px;\n    color: #fff;\n    font-weight: 600;\n}\n\n.header .logo .logo-img span {\n    font-weight: 600;\n    color: #F94892;\n}\n\n.header .logo .logo-img .blink {\n    animation: blink 2s infinite;\n}\n\n@keyframes blink {\n    0% {\n        color: #F94892;\n    }\n\n    50% {\n        color: transparent;\n    }\n    100% {\n        color: #F94892;\n        \n    }\n}\n\n.header .nav-menu{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    flex-basis: 70%;\n}\n\n.nav-menu li{\n    width: max-content;\n    padding: 10px;\n    transform: rotate(270deg);\n}\n\n.nav-menu li .navLink{\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n}\n.nav-menu li .navLink:hover {\n    color: #F94892;\n}\n\n.nav-menu li {\n    transition: all 0.5s ease-in-out;\n}\n\n.nav-menu li:hover {\n    color: #F94892;\n    transform: scale(1.3) rotate(270deg);\n}\n\n.header .social-links {\n    width: 3rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.header .social-links .social{\n    margin: 5px 0;\n    width: 100%;\n    transition: all 0.5s ease-in-out;\n}\n\n.header .hamburger {\n    display: none;\n}\n\n.header .social-links .social:hover {\n    transform: scale(1.5);\n    fill: #F94892;\n}\n\n\n@media screen and (max-width: 750px), (max-height: 550px) {\n    .header {\n        width: 100vw;\n        height: auto;\n        flex-direction: row;\n        padding: 10px 20px;\n        z-index: 100;\n        backdrop-filter: blur(30px);\n    }\n\n    .header .logo {\n        width: auto;\n        height: auto;\n        margin: 0;\n    }\n\n    .header .logo .logo-img {\n        font-size: 40px;\n    }\n\n    .header .hamburger {\n        display: initial;\n        z-index: 10;\n    }\n\n    .header .hamburger .bars {\n        height: 100%;\n    }\n\n    .header .nav-menu {\n        width: 50vw;\n        position: absolute;\n        top: 0;\n        height: 85vh;\n        right: -100%;\n        transition: 0.5s;\n        background: rgb(18, 18, 18);\n    }\n\n    .header .nav-menu.active {\n        right: 0;\n        z-index: 10;\n    }\n\n    .header .nav-menu li {\n        transform: rotate(0deg);\n        padding: 5px 10px;\n        z-index: 12;\n        transition: all 0.3s ease-in-out;\n    }\n\n    .nav-menu li:hover {\n        transform: scale(1.12);\n    }\n\n    .header .social-links {\n        padding: 2rem;\n        position: absolute;\n        top: 85vh;\n        height: 20vh;\n        right: -100%;\n        width: 50%;\n        flex-direction: row;\n        justify-content: space-evenly;\n        transition: 0.5s;\n        z-index: 110;\n        background: rgb(18, 18, 18);\n    }\n\n    .header .social-links.active {\n        right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
